import {
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_SERVICES_MARKETPLACE } from "../domain";

import { servicesMarketplaceApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_SET_SERVICE_IM_INTERESTED = "SET_SERVICE_IM_INTERESTED";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const setServiceImInterested = async (
  serviceId: number,
): Promise<void> => {
  const response = await servicesMarketplaceApi.serviceMarketplaceControllerSetServiceImInterested(serviceId);

  return response.data;
};

export const useSetServiceImInterested = (
  user: UserProfileDto | null,
): {
  setServiceImInterested: UseMutateFunction<void, Error, number>;
  setServiceImInterestedEnabled: boolean;
  isSuccessSetServiceImInterested: boolean;
  isPendingSetServiceImInterested: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_SERVICES_MARKETPLACE, ACTION_SET_SERVICE_IM_INTERESTED],
    mutationFn: enabled ? setServiceImInterested : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_SERVICES_MARKETPLACE] });
    },
  });

  return {
    setServiceImInterested: mutate,
    setServiceImInterestedEnabled: enabled,
    isSuccessSetServiceImInterested: isSuccess,
    isPendingSetServiceImInterested: isPending,
  };
};
